import { createApiMutationHook, IApiMutationFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ILanguageResource } from "../types";

export interface ILanguageUpdateMutationParameters {
    language: RelationalValue<ILanguageResource>;
    title: string;
    locale: string;
}

export type ILanguageUpdateMutationResult = ILanguageResource;

export const languageUpdateMutation: IApiMutationFunction<ILanguageUpdateMutationParameters> = ({
    language,
    title,
    locale,
}) => ({
    method: "PUT",
    url: `/languages/${mapRelationalValue(language)}`,
    data: {
        title,
        locale,
    },
});

export const useLanguageUpdateMutation = createApiMutationHook<
    ILanguageUpdateMutationParameters,
    ILanguageUpdateMutationResult
>(languageUpdateMutation);
